import React, { useEffect, useState } from 'react';

import clsx from 'clsx';
import {
  Button,
  TextField,
  makeStyles,
  ClickAwayListener,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import styles from './CustomSelect.module.scss';

// Please shift the following Styling to linked css file ;
const useStyles = makeStyles({
  root: {
    width: '100%',
    position: 'relative',
    '& svg': {
      verticalAlign: 'middle',
    },
  },
  width__auto: {
    width: 'auto',
  },
  btnStyle: {
    border: '1px solid #dde9fb',
    borderRadius: '10px',
    background: '#fff',
    color: '#6D7D8B',
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 15px',
    width: '10rem',
    cursor: 'pointer',
    textTransform: 'capitalize',
  },

  item: {
    borderBottom: '0.25px solid #E1E1E1',
  },

  itemDisabled: {
    cursor: 'default',
    pointerEvents: 'none',
    opacity: '.5',
  },

  icon: {
    '& svg': {
      verticalAlign: 'middle',
    },
    flex__center: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  opacity__half: {
    pointerEvents: 'none',
    '& .MuiButton-label': {
      opacity: '.5',
    },
  },
  hidden__field: {
    borderBottom: '0.25px solid #E1E1E1',
    '& input': {
      padding: '0.5rem',
    },
  },
  state__div: {
    fontSize: '14px',
    fontWeight: '600',
    padding: '0.7rem 0.5rem',
  },
});

export default function CustomSelect({
  menuItems,
  customStyle,
  handleChange,
  disabled,
  value,
  customBody = false,
  children,
  className,
  icon,
  onBlur,
  iconStyle = {},
  hideCustomBody = false,
  usedIn,
  widthAuto,
  testId = '',
  multiSelect = false,
  selectedValues = [],
  haveSearchInput,
  plateLookUp,
  allPayment,
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [hiding, setHiding] = React.useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [filteredValues, setFilteredValues] = useState();
  const [usaValues, setUsaValues] = useState();
  const [canadaValues, setCanadaValues] = useState();

  useEffect(() => {
    if (menuItems?.length && !filteredValues?.length) {
      if (plateLookUp) {
        setUsaValues(menuItems.filter((item) => item.state === 'US'));
        setCanadaValues(menuItems.filter((item) => item.state === 'CN'));
      } else {
        setFilteredValues(menuItems);
      }
    }
  }, [menuItems]);

  // I am closing The Dropdown after a slight delay (100 ms);
  // during 100 ms i am adding a class to dropdown and animating it.
  const hideSlowly = () => {
    setHiding(true);
    setTimeout(() => {
      setOpen(false);
    }, 100);
  };
  const handleClick = () => {
    if (open) {
      hideSlowly();
    } else {
      setOpen(true);
    }
  };

  useEffect(() => {
    if (hideCustomBody) {
      hideSlowly();
    }
  }, [hideCustomBody]);

  const handleItem = (item) => {
    handleChange(item);
    hideSlowly();
    onBlur?.();
  };

  const getMessage = () => {
    const selectionWords = ['select', 'set'];
    const inCommingMessage = selectionWords?.includes(
      value?.toString()?.split(' ')?.[0]?.toLowerCase(),
    )
      ? value?.toString()?.split(' ')?.slice(1)
      : null;
    const message = inCommingMessage?.join(' ') || 'data';
    return message;
  };
  // const skipHtml = (html) => {
  //   const doc = new DOMParser().parseFromString(html, 'text/html');
  //   return doc.body.textContent || '';
  // };
  const handleSearch = (e) => {
    let valueSearch = e.target.value;
    valueSearch = valueSearch.trimStart();

    setSearchValue(valueSearch);

    if (plateLookUp) {
      const lowerCaseSearch = valueSearch?.toLowerCase() || '';

      const filterItems = (state) =>
        menuItems.filter(
          (item) =>
            item.state === state &&
            item.value?.toLowerCase().includes(lowerCaseSearch),
        );

      if (!valueSearch || valueSearch === '') {
        setUsaValues(menuItems.filter((item) => item.state === 'US'));
        setCanadaValues(menuItems.filter((item) => item.state === 'CN'));
      } else {
        const usSearchedArr = filterItems('US');
        const canadaSearchedArr = filterItems('CN');

        setUsaValues(usSearchedArr);
        setCanadaValues(canadaSearchedArr);

        if (!usSearchedArr.length) setUsaValues([]);
        if (!canadaSearchedArr.length) setCanadaValues([]);
      }
    } else {
      if (!valueSearch || valueSearch === '') {
        setFilteredValues(menuItems);
        return false;
      }
      const searchedArr = menuItems?.filter((item) => {
        if (item.value?.toLowerCase()?.includes(valueSearch.toLowerCase())) {
          return true;
        }
      });
      setFilteredValues(searchedArr);
    }
  };

  React.useEffect(() => {
    setHiding(!open);
  }, [open]);

  const renderStates = (items, state) => (
    <>
      <div className={classes.state__div}>{state}</div>
      {items?.length ? (
        items.map((item) => (
          <div
            key={item.value}
            onClick={() => {
              handleItem(item);
              setSearchValue('');
              setUsaValues(menuItems.filter((elem) => elem.state === 'US'));
              setCanadaValues(menuItems.filter((elem) => elem.state === 'CN'));
            }}
            className={clsx(styles.item, styles.itemSpacing)}
          >
            {item.name ?? ''}
          </div>
        ))
      ) : (
        <div className={clsx(styles.item, styles.itemSpacing)}>No State</div>
      )}
    </>
  );

  return (
    <>
      <ClickAwayListener
        mouseEvent='onMouseDown'
        touchEvent='onTouchStart'
        onClickAway={hideSlowly}
      >
        <div
          className={clsx(
            classes.root,
            'p-relative',
            (usedIn === 'internalCatalog' || widthAuto) && classes.width__auto,
          )}
        >
          <Button
            className={clsx(
              className,
              classes.btnStyle,
              disabled && classes.opacity__half,
            )}
            title={value ?? ''}
            type='button'
            data-testid={testId}
            style={{
              ...customStyle,
            }}
            onClick={handleClick}
            disabled={disabled}
            // onBlur={onBlur}
          >
            <div
              className='d-flex align-center w-100'
              style={{ maxWidth: '96%' }}
            >
              {icon && (
                <span className={classes.icon} style={{ ...iconStyle }}>
                  {icon}
                </span>
              )}
              <span
                className={clsx(
                  classes.selectedStyleTxt,
                  'customSelectSpn',
                  classes.flex__center,
                )}
              >
                {(usedIn === 'estimate'
                  ? value + '%' ?? menuItems?.[0]?.name
                  : value ?? menuItems?.[0]?.name) || 'Select'}
              </span>
            </div>
            <span className={open && styles.rotate}>
              {allPayment ? '▾' : <ExpandMoreIcon />}
            </span>
          </Button>
          {open ? (
            customBody ? (
              children
            ) : (
              <div
                className={clsx(
                  styles.customDropdown_body,
                  hiding && open && styles.fadeOut,
                  'zindex',
                  'drop__down__body',
                )}
              >
                {menuItems?.length ? (
                  <div className={styles.list__main}>
                    {haveSearchInput && (
                      <div>
                        <TextField
                          autoFocus
                          fullWidth
                          placeholder='Search'
                          value={searchValue}
                          onChange={handleSearch}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className={classes.hidden__field}
                        />
                      </div>
                    )}
                    {haveSearchInput ? (
                      plateLookUp ? (
                        <div>
                          {renderStates(usaValues, 'USA')}
                          {renderStates(canadaValues, 'CANADA')}
                        </div>
                      ) : (
                        filteredValues?.map((item, i) => (
                          <div
                            key={
                              item?.id ||
                              item?.value?.toString()?.split(' ')?.join('') ||
                              i++
                            }
                            onClick={() => {
                              handleItem(item);
                              setSearchValue('');
                              setFilteredValues(menuItems);
                            }}
                            className={clsx(
                              i !== menuItems?.length - 1 && classes?.item,
                              item?.disabled && classes.itemDisabled,
                              item?.name === value && styles.selectedItem,
                              styles.itemSpacing,
                              multiSelect &&
                                selectedValues.includes(item?.name) &&
                                styles.multiSelectedValue,
                            )}
                          >
                            {usedIn === 'estimate'
                              ? item?.name + ' (' + item?.value + '%)'
                              : item?.name ?? ''}
                          </div>
                        ))
                      )
                    ) : (
                      menuItems?.map((item, i) => (
                        <div
                          key={
                            item?.id ||
                            item?.value?.toString()?.split(' ')?.join('') ||
                            i++
                          }
                          onClick={() => handleItem(item)}
                          className={clsx(
                            i !== menuItems?.length - 1 && classes?.item,
                            item?.disabled && classes.itemDisabled,
                            item?.name === value && styles.selectedItem,
                            styles.itemSpacing,
                            'drop__down__list',
                            multiSelect &&
                              selectedValues.includes(item?.name) &&
                              styles.multiSelectedValue,
                          )}
                        >
                          {usedIn === 'estimate'
                            ? item?.name + ' (' + item?.value + '%)'
                            : item?.name ?? ''}
                        </div>
                      ))
                    )}
                  </div>
                ) : (
                  <small className={styles.noOptionMessage}>
                    No&nbsp;
                    {getMessage()} Found
                  </small>
                )}
              </div>
            )
          ) : null}
        </div>
      </ClickAwayListener>
    </>
  );
}
